var _defs, _ellipse, _ellipse2, _ellipse3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse0, _path19, _path20, _path21, _path22, _ellipse1, _ellipse10, _path23, _path24, _path25, _path26;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrake(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 240 240",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "d-body",
    cx: "55%",
    cy: "45%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3a1a0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#1a0a04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0d0604"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d-molten",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fff4a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#ffaa00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#cc4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#6a1500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d-eye",
    cx: "40%",
    cy: "35%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fffac0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40%",
    stopColor: "#ffcc00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ff6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d-throat",
    cx: "50%",
    cy: "30%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fff8a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "35%",
    stopColor: "#ffaa00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#cc3300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#220500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d-scale-hi",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#8a4020",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1a0804",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d-smoke1",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#554433",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#220a00",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d-glow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80,
    cy: 35,
    rx: 28,
    ry: 18,
    fill: "url(#d-smoke1)",
    opacity: 0.6
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60,
    cy: 20,
    rx: 18,
    ry: 12,
    fill: "url(#d-smoke1)",
    opacity: 0.4
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 18,
    rx: 14,
    ry: 9,
    fill: "url(#d-smoke1)",
    opacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 120 200 C 110 170 95 140 100 110 C 105 85 115 70 130 60 L 175 55 C 195 70 200 95 190 120 C 180 150 160 175 145 200 Z",
    fill: "url(#d-body)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 120 200 C 110 170 95 140 100 110 C 105 85 115 70 130 60 L 175 55 C 195 70 200 95 190 120 C 180 150 160 175 145 200 Z",
    fill: "url(#d-scale-hi)",
    opacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 135 80 Q 145 75 155 80 Q 145 88 135 80Z",
    fill: "#5a2810",
    opacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 155 90 Q 168 84 178 90 Q 167 99 155 90Z",
    fill: "#5a2810",
    opacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 140 105 Q 152 98 163 105 Q 152 114 140 105Z",
    fill: "#5a2810",
    opacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 160 118 Q 173 110 184 118 Q 172 128 160 118Z",
    fill: "#5a2810",
    opacity: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 130 125 Q 140 118 150 125 Q 140 134 130 125Z",
    fill: "#5a2810",
    opacity: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 120 148 Q 131 140 143 148 Q 131 157 120 148Z",
    fill: "#5a2810",
    opacity: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 145 185 Q 150 160 155 140 Q 160 120 158 100",
    fill: "none",
    stroke: "#cc5500",
    strokeWidth: 1.2,
    opacity: 0.5
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M 130 175 Q 125 155 128 135",
    fill: "none",
    stroke: "#aa3300",
    strokeWidth: 0.8,
    opacity: 0.4
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M 55 105 C 60 80 80 60 108 58 C 125 57 138 62 145 78 C 152 95 148 118 135 130 C 118 145 90 148 70 138 C 52 128 50 120 55 105Z",
    fill: "url(#d-body)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 55 105 C 60 80 80 60 108 58 C 125 57 138 62 145 78 C 152 95 148 118 135 130 C 118 145 90 148 70 138 C 52 128 50 120 55 105Z",
    fill: "url(#d-scale-hi)",
    opacity: 0.6
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 55 105 C 40 108 25 115 18 128 C 14 136 22 144 35 140 C 48 136 58 128 68 122Z",
    fill: "#1a0a04"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 55 105 C 40 108 25 115 18 128 C 14 136 22 144 35 140 C 48 136 58 128 68 122Z",
    fill: "url(#d-scale-hi)",
    opacity: 0.4
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 20 132 C 28 140 44 148 62 148 C 72 148 78 143 72 136 C 62 125 50 128 38 132Z",
    fill: "#150806"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M 22 133 L 26 144 L 30 133Z",
    fill: "#e8d4b0",
    opacity: 0.8
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M 35 135 L 39 147 L 43 135Z",
    fill: "#e8d4b0",
    opacity: 0.8
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M 50 136 L 54 146 L 58 136Z",
    fill: "#e8d4b0",
    opacity: 0.7
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M 24 130 L 28 120 L 32 130Z",
    fill: "#d4c09a",
    opacity: 0.7
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M 40 128 L 44 118 L 48 128Z",
    fill: "#d4c09a",
    opacity: 0.7
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78,
    cy: 134,
    rx: 28,
    ry: 12,
    fill: "url(#d-throat)",
    opacity: 0.9,
    filter: "url(#d-glow)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72,
    cy: 130,
    rx: 18,
    ry: 8,
    fill: "#ffcc44",
    opacity: 0.3
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92,
    cy: 93,
    rx: 14,
    ry: 11,
    fill: "#110500"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92,
    cy: 93,
    rx: 14,
    ry: 11,
    fill: "url(#d-eye)",
    filter: "url(#d-glow)"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92,
    cy: 93,
    rx: 7,
    ry: 8,
    fill: "#ffee66"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92,
    cy: 93,
    rx: 3,
    ry: 5,
    fill: "#cc2200"
  })), _ellipse0 || (_ellipse0 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 89,
    cy: 90,
    rx: 2,
    ry: 1.5,
    fill: "#fffacc",
    opacity: 0.9
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M 78 83 Q 92 76 108 80",
    fill: "none",
    stroke: "#3a1a08",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M 78 83 Q 92 76 108 80",
    fill: "none",
    stroke: "#6a3015",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    opacity: 0.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M 108 68 C 112 52 120 38 115 22 C 112 32 105 44 100 58Z",
    fill: "#2a1206"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M 108 68 C 115 54 128 42 130 28 C 124 40 116 52 108 68Z",
    fill: "#2a1206"
  })), _ellipse1 || (_ellipse1 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45,
    cy: 118,
    rx: 5,
    ry: 3,
    fill: "#cc4400",
    opacity: 0.6
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 46,
    cy: 112,
    rx: 8,
    ry: 5,
    fill: "#774422",
    opacity: 0.25
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M 75 62 Q 108 52 138 65",
    fill: "none",
    stroke: "#cc6620",
    strokeWidth: 2,
    opacity: 0.5,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M 165 70 C 190 50 215 40 220 65 C 222 80 210 95 195 90 C 185 87 175 80 165 70Z",
    fill: "#1a0a04",
    opacity: 0.85
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M 165 70 C 190 50 215 40 220 65 C 222 80 210 95 195 90 C 185 87 175 80 165 70Z",
    fill: "url(#d-scale-hi)",
    opacity: 0.3
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M 168 73 C 192 55 215 48 218 67",
    fill: "none",
    stroke: "#5a2810",
    strokeWidth: 1,
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrake);
export default __webpack_public_path__ + "static/media/drake.57b1a13a6d743398bd56e942bb371db2.svg";
export { ForwardRef as ReactComponent };